// Module
var code = "<template>\n    <require from=\"./../offer/offer-list-table\"></require>    \n    <offer-list-table if.bind=\"params.Id\" params.bind=\"params\" context=\"customer-view\" customerid.bind=\"params.Id\"></offer-list-table>\n</template> \n";
// Exports
export default code;